<template>
  <g>
    <g v-if="activeHohlschnitt && materialComplete">
      <path d="M75 75 q30 175 0 350 q175 -30 350 0 q-30 -175 0 -350 q-175 30 -350 0" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
      <polygon v-for="(corner, index) in hohlschnitt" :key="index" :points="corner" stroke="#b1b1b1" stroke-width="2" fill="#fff"/>
    </g>
    <rect v-else x="250" y="250" transform="translate(-175,-175)" width="350" height="350" stroke="#b1b1b1" stroke-width="1" :style="materialColor.hex != '' && formComplete ? {'fill': materialColor.hex} : {'fill': '#fff'}"/>
    <g v-if="formComplete">
      <g v-for="(side, index) in sides" :key="index">
        <line :x1="side.border.line.xStart" :y1="side.border.line.yStart" :x2="side.border.line.xEnd" :y2="side.border.line.yEnd" stroke="#ddd" stroke-width="1"/>
        <polygon :points="side.border.corner.start" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <polygon :points="side.border.corner.end" stroke="#ddd" stroke-width="1" fill="#ddd"/>
        <rect :x="side.labelBackground.x" :y="side.labelBackground.y" :width="side.labelBackground.width" :height="side.labelBackground.height" style="fill:#fff" />
      </g>
    </g>
    <text v-for="side in sides" :key="side.id" dominant-baseline="middle" text-anchor="middle" fill="#002b36">
      <tspan v-if="formComplete" :x="side.labelSpace.x" :y="side.labelSpace.y" class="font-weight-bold" font-size="1em">{{side.name}}</tspan>
      <tspan v-if="formComplete" :x="side.labelSpace.x" dy="1.5em" font-size="0.7em">{{side.size}} cm</tspan>
      <tspan v-if="materialComplete" :x="side.labelSpace.x" dy="1em" font-size="0.7em">{{side.rand}}</tspan>
    </text>
    <g v-if="materialComplete">
      <g v-for="side in sides" :key="side.id">
        <g v-if="side.rand === rand.saum.titleSaum.name">
          <path :d="side.saum" stroke-width="1" stroke="#b1b1b1" stroke-dasharray="3,3"/>
          <g v-if="activeOesenArt">
            <circle v-for="(item, index) in side.oesenAnzahl" :key="index" :cx="side.oesenAbstand.x(index, side.oesenAnzahl)" :cy="side.oesenAbstand.y(index, side.oesenAnzahl)" r="3" stroke="#b1b1b1" stroke-width="2" fill="#fff" />
          </g>
        </g>
        <path v-if="side.rand === rand.hohlsaum.title.name" :d="side.hohlsaum" stroke-width="1" stroke="#b1b1b1"/>
        <g v-if="side.rand === rand.keder.title.name" stroke="#b1b1b1" stroke-opacity="0">
          <rect :x="side.keder.outside.xStart" :y="side.keder.outside.yStart" :width="side.keder.outside.width" :height="side.keder.outside.height" fill="#b1b1b1"/>
          <rect :x="side.keder.inside.xStart" :y="side.keder.inside.yStart" :width="side.keder.inside.width" :height="side.keder.inside.height" fill="#8e8e8e"/>
        </g>
      </g>
    </g>
  </g>
</template>

<script>
import DataRandArt from '../../../../../data/main/config/setup/rand/randArt'

import { mapGetters } from 'vuex'

export default {
  data () {
    return {
      rand: DataRandArt.randArt,
      hohlschnitt: {
        cornerLU: '70,80 70,70 80,70',
        cornerRU: '420,70 430,70 430,80',
        cornerLD: '70,420 70,430 80,430',
        cornerRD: '430,420 430,430 420,430'
      }
    }
  },
  computed: {
    ...mapGetters([
      'materialColor',
      'randSides',
      'formComplete',
      'materialComplete',
      'activeOesenArt',
      'activeHohlschnitt',
      'calcSides'
    ]),
    sides () {
      return {
        a: {
          name: 'a',
          size: Math.round(this.calcSides[0]),
          rand: this.randSides[0].type.name,
          oesenAnzahl: this.randSides[0].oesenAnzahl,
          oesenAbstand: {
            x: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            },
            y: function (i, item) {
              return 410
            }
          },
          saum: 'M75 395 L425 395',
          hohlsaum: 'M75 416 L425 416',
          keder: {
            outside: {
              xStart: 75,
              yStart: 416,
              width: 350,
              height: 9
            },
            inside: {
              xStart: 75,
              yStart: 422,
              width: 350,
              height: 3
            }
          },
          labelSpace: {
            x: 250,
            y: 455
          },
          labelBackground: {
            x: 215,
            y: 437,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 465,
              xEnd: 425,
              yEnd: 465
            },
            corner: {
              start: '75,465 85,460 85,470',
              end: '425,465 415,460 415,470'
            }
          },
          id: 1
        },
        b: {
          name: 'b',
          size: Math.round(this.calcSides[1]),
          rand: this.randSides[1].type.name,
          oesenAnzahl: this.randSides[1].oesenAnzahl,
          oesenAbstand: {
            x: function (i, item) {
              return 90
            },
            y: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            }
          },
          saum: 'M105 75 L105 425',
          hohlsaum: 'M84 75 L84 425',
          keder: {
            outside: {
              xStart: 75,
              yStart: 75,
              width: 9,
              height: 350
            },
            inside: {
              xStart: 75,
              yStart: 75,
              width: 3,
              height: 350
            }
          },
          labelSpace: {
            x: 35,
            y: 250
          },
          labelBackground: {
            x: 0,
            y: 231,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 35,
              yStart: 75,
              xEnd: 35,
              yEnd: 425
            },
            corner: {
              start: '35,75 30,85 40,85',
              end: '35,425 30,415 40,415'
            }
          },
          id: 2
        },
        c: {
          name: 'c',
          size: Math.round(this.calcSides[2]),
          rand: this.randSides[2].type.name,
          oesenAnzahl: this.randSides[2].oesenAnzahl,
          oesenAbstand: {
            x: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            },
            y: function (i, item) {
              return 90
            }
          },
          saum: 'M75 105 L425 105',
          hohlsaum: 'M75 84 L425 84',
          keder: {
            outside: {
              xStart: 75,
              yStart: 75,
              width: 350,
              height: 9
            },
            inside: {
              xStart: 75,
              yStart: 75,
              width: 350,
              height: 3
            }
          },
          labelSpace: {
            x: 250,
            y: 27
          },
          labelBackground: {
            x: 215,
            y: 10,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 75,
              yStart: 35,
              xEnd: 425,
              yEnd: 35
            },
            corner: {
              start: '75,35 85,30 85,40',
              end: '425,35 415,30 415,40'
            }
          },
          id: 3
        },
        d: {
          name: 'd',
          size: Math.round(this.calcSides[3]),
          rand: this.randSides[3].type.name,
          oesenAnzahl: this.randSides[3].oesenAnzahl,
          oesenAbstand: {
            x: function (i, item) {
              return 410
            },
            y: function (i, item) {
              if (item === 1) {
                return 250
              } else if (item === 2) {
                return 90 + i * 320
              } else {
                return 90 + 320 * (i / (item - 1))
              }
            }
          },
          saum: 'M395 75 L395 425',
          hohlsaum: 'M416 75 L416 425',
          keder: {
            outside: {
              xStart: 416,
              yStart: 75,
              width: 9,
              height: 350
            },
            inside: {
              xStart: 422,
              yStart: 75,
              width: 3,
              height: 350
            }
          },
          labelSpace: {
            x: 465,
            y: 250
          },
          labelBackground: {
            x: 430,
            y: 231,
            width: 70,
            height: 60
          },
          border: {
            line: {
              xStart: 465,
              yStart: 75,
              xEnd: 465,
              yEnd: 425
            },
            corner: {
              start: '465,75 460,85 470,85',
              end: '465,425 460,415 470,415'
            }
          },
          id: 4
        }
      }
    }
  }
}
</script>

<style>
</style>
